module.exports = __webpack_public_path__ + "img/Bodice-Front-B8-Gb-Da-Ea.4aaebb23.png";